<script setup>
defineProps({
  active: Number,
  steps: {
      type: Array
  },
})
</script>
<template>
  <div class="d--sidebar d--sidebar-light d--bg-gray-50 fixed-right sidebar-width flex-row">
    <div class="hreg--steps">
      <div class="hreg--timeline">
        <div v-for="step in steps" :key="step.key" :class="[
          'd--timeline-item',
          steps.length == step.key && 'last',
          step.key == active ? 'active' : step.key < active ? 'done' : '',
        ]">
          <div class="d--timeline-item-badge">
            <i class="mdi mdi-check-bold"></i>
          </div>
          <div class="d--timeline-item-body">
            <h5>{{ step.key }}</h5>
            <small>{{ $t(step.label) }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.sidebar-width {
  width: 320px;
}
.hreg--steps {
  padding-top: 150px;
  position: sticky;
}
.d--timeline-item-body {
  display: flex; 
  justify-content: space-between;
  align-items: center;
  width: 100%; 
}

.d--timeline-item-body h5,
.d--timeline-item-body small {
  flex: 1; 
  text-align: left;
  margin-top: 0px; 
}

.d--timeline-item-body h5{
  max-width: 20px;
  min-width: 20px;
}
</style>